<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <LeituraKit />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>

<script>
import LeituraKit from "../Components/Leituras/LeituraKit.vue";
export default {
  name: "ReadHotel",
  components: {
    LeituraKit,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>